"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1233],{

/***/ 1233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tm_ui_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7510);
/* harmony import */ var _index_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6440);
/* harmony import */ var _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9753);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var _tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6431);
/* harmony import */ var _TMLogoLanding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7055);
/* harmony import */ var _tm_utility_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8217);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2322);











var HeaderLanding = function HeaderLanding(_ref) {
  var tmLogo = _ref.tmLogo,
      faq = _ref.faq,
      faqCTAEvent = _ref.faqCTAEvent,
      aboutUs = _ref.aboutUs,
      onClickFaqLink = _ref.onClickFaqLink,
      faqRedirectionUrl = _ref.faqRedirectionUrl;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true),
      isLight = _useState[0],
      setIsLight = _useState[1];

  (0,_tm_ui_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useHeaderAnimation */ .g3)(setIsLight);

  var onClickFaq = function onClickFaq() {
    if (faqCTAEvent) (0,_tm_utility_analytics__WEBPACK_IMPORTED_MODULE_6__/* .pushEvent */ .AB)(faqCTAEvent);

    if (typeof onClickFaqLink === "function") {
      onClickFaqLink();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_1__/* .LandingHeader */ .Sx, {
    id: "header_ref",
    isLight: isLight,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_1__/* .LandingHeaderWrap */ .I8, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_index_style__WEBPACK_IMPORTED_MODULE_1__/* .TMLogo */ .Vh // href={tmLogo?.redirectUrl}
      , {
        "aria-label": tmLogo === null || tmLogo === void 0 ? void 0 : tmLogo.name,
        id: (0,_tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .getElementUniqueIds */ .QB)(_tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .PageNameMapping.LISTING_PAGE */ .XH.LISTING_PAGE, _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .SectionNameMapping.HEADER */ .Rw.HEADER, _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .ElementNameMapping.TM_LOGO */ .vT.TM_LOGO),
        className: "darkRef",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_TMLogoLanding__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          isLight: isLight
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_index_style__WEBPACK_IMPORTED_MODULE_1__/* .LandingHeaderList */ .N2, {
        children: [faq && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
          id: (0,_tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .getElementUniqueIds */ .QB)(_tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .PageNameMapping.LISTING_PAGE */ .XH.LISTING_PAGE, _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .SectionNameMapping.HEADER */ .Rw.HEADER, _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .ElementNameMapping.FAQ */ .vT.FAQ),
          children: faqRedirectionUrl ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
            href: faqRedirectionUrl,
            children: faq.title
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .ActiveLink */ .O$, {
            href: _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .LINKS.FAQ */ .BA.FAQ,
            "aria-label": faq.title,
            onClick: onClickFaq,
            children: faq.title
          })
        }), aboutUs && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("li", {
          id: (0,_tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .getElementUniqueIds */ .QB)(_tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .PageNameMapping.LISTING_PAGE */ .XH.LISTING_PAGE, _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .SectionNameMapping.HEADER */ .Rw.HEADER, _tm_utility_constants__WEBPACK_IMPORTED_MODULE_2__/* .ElementNameMapping.ABOUT_US */ .vT.ABOUT_US),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_ui_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .ActiveLink */ .O$, {
            href: aboutUs.redirectUrl,
            "aria-label": aboutUs.title,
            children: aboutUs.title
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (HeaderLanding);

/***/ })

}]);